import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {BoardSearch, BoardState} from '../model/BoardSearch'

//* 초기 상태
const initialState: BoardState = {
    categoryId: 0,
    searchText: '',
    s: false
};

const board = createSlice({
    name: 'board',
    initialState,
    reducers: {
        setSearch(state, action: PayloadAction<BoardState>) {
            state = {
                ...state,
                searchText: action.payload.searchText,
                s: true,
                categoryId: action.payload.categoryId
            };
            return state;
        },
        //* 초기화 하기
        init(state) {
            state = initialState;
            return state;
        }
    }
});

export const boardActions = {...board.actions};

export default board;
